import { render } from "./GoldCoinRewardRaceGame.vue?vue&type=template&id=34b60c6c"
import script from "./GoldCoinRewardRaceGame.vue?vue&type=script&lang=js"
export * from "./GoldCoinRewardRaceGame.vue?vue&type=script&lang=js"

import "./GoldCoinRewardRaceGame.vue?vue&type=style&index=0&id=34b60c6c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__